import useApiEntitySchemasOfContext from '../../Hooks/useApiEntitySchemasOfContext';
import GenericContextInputItemDialog from './GenericContextInputItemDialog';
import { SchemaRefModel } from '../../Models/DomainServiceModel';
import useFlowQueries from '../../Hooks/useFlowQueries';
import { useQuery } from '@tanstack/react-query';

type SchemaInputDialogProps = {
	open: boolean;
	setOpen: (open: boolean) => void;
	schemaRef: SchemaRefModel | undefined;
	onSchemaRefChange: (schemaRef: SchemaRefModel | undefined) => void;
};

export function SchemaInputDialog({ open, setOpen, schemaRef, onSchemaRefChange }: SchemaInputDialogProps) {
	const flowsQueries = useFlowQueries();
	const { data: existingEntity } = useQuery(flowsQueries.queryEntitySchemaByRef(schemaRef, true));

	return (
		<GenericContextInputItemDialog
			open={open}
			setOpen={setOpen}
			item={existingEntity}
			onItemChange={(item, context) =>
				onSchemaRefChange?.(item ? ({ Id: item.id, Name: item.name, ContextId: item.contextId, ContextName: context?.name } as SchemaRefModel) : undefined)
			}
			itemsOfContext={useApiEntitySchemasOfContext}
			what="Schema"
		/>
	);
}
